import React from 'react';
import type { Tool } from '../../types/tools';
import { Reveal } from '../ui/Reveal';
import { Eyebrow } from '../ui/Eyebrow';

/** Standalone short answer: what the tool is, who it is for, inputs and outputs. */
export function ToolExplainer({
  tool
}: {
  tool: Tool;
}) {
  return <section aria-labelledby="what-is-heading" className="border-b border-hairline-soft bg-ink" data-id="element-1123" data-mp="2g57crbpzj3cl">
      <div className="mx-auto grid w-full max-w-[1320px] gap-8 px-4 py-20 sm:px-6 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-16 lg:px-8 lg:py-24" data-id="element-1124" data-mp="1sfmm06nlb1sr">
        <Reveal className="flex flex-col gap-4" data-id="element-1125" data-mp="1ni32osc1byty">
          <Eyebrow data-id="element-1126" data-mp="217ok3ya6s5zv">Short answer</Eyebrow>
          <h2 id="what-is-heading" className="sf-display text-balance text-[32px] leading-[1.06] text-text-primary sm:text-[42px]" data-id="element-1127" data-mp="219hot818og58">
            {tool.whatIs.question}
          </h2>
        </Reveal>
        <Reveal delay={0.06} className="flex max-w-2xl flex-col gap-4" data-id="element-1128" data-mp="18q2ohscydg01">
          {tool.whatIs.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} className="text-base leading-relaxed text-text-secondary" data-id="element-1129" data-mp="14o7ocr6rd8nu">
              {paragraph}
            </p>)}
        </Reveal>
      </div>
    </section>;
}